<section class="ephemeris-page">
  <header class="ephemeris-page__header">
    <h1 class="ephemeris-page__title">{{ title() }}</h1>
  </header>
  <hd-ephemeris-table class="ephemeris-page__table"></hd-ephemeris-table>
</section>
